import React from 'react';
import { Compass, Building2, Home, Trees, CheckCircle2, FileText, HardHat, Leaf } from 'lucide-react';
import ScrollReveal from '../components/ScrollReveal';
import './Missions.css';
import SEO, { seoConfig } from '../components/SEO';

export default function Missions({ t }) {
  // Icônes pour chaque mission
  const missionIcons = [
    <Compass size={48} strokeWidth={1.5} />,
    <Building2 size={48} strokeWidth={1.5} />,
    <Home size={48} strokeWidth={1.5} />,
    <Trees size={48} strokeWidth={1.5} />
  ];

  // Images des projets pour chaque type de mission
  const missionImages = [
    '/images/projets/pierre-vives/1.webp',
    '/images/projets/ovalie/1.webp',
    '/images/projets/maisonbbc/1.webp',
    '/images/projets/policebaillargue/1.webp'
  ];

  return (
    <div className="missions-page">
      {/* SEO Component */}
      <SEO 
        title={seoConfig.missions.title}
        description={seoConfig.missions.description}
        keywords={seoConfig.missions.keywords}
      />

      <div className="page-container">
        {/* En-tête */}
        <ScrollReveal>
          <h1 className="page-title page-mb">{t.missions.title}</h1>
          <p className="page-subtitle">{t.missions.subtitle}</p>
        </ScrollReveal>

        {/* Introduction */}
        <ScrollReveal delay={0.1}>
          <div className="missions-intro">
            <p className="missions-intro-text">
              {t.missions.intro}
            </p>
          </div>
        </ScrollReveal>

        {/* Grille des missions */}
        <div className="missions-grid">
          {t.missions.types.map((mission, idx) => (
            <ScrollReveal key={idx} delay={idx * 0.1 + 0.2}>
              <div className="mission-card">
                <div className="mission-image">
                  <img
                    src={missionImages[idx]}
                    alt={mission.title}
                    className="mission-img"
                    loading='lazy'
                  />
                  <div className="mission-overlay" />
                  <div className="mission-icon-overlay">
                    {missionIcons[idx]}
                  </div>
                </div>

                <div className="mission-content">
                  <h3 className="mission-title">{mission.title}</h3>
                  <p className="mission-description">{mission.description}</p>
                  
                  <ul className="mission-highlights">
                    {mission.highlights.map((highlight, hIdx) => (
                      <li key={hIdx}>
                        <CheckCircle2 size={16} /> {highlight}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Phase Études */}
        <ScrollReveal delay={0.6}>
          <section className="mission-phase-section">
            <div className="phase-header">
              <div className="phase-icon">
                <FileText size={40} strokeWidth={1.5} />
              </div>
              <h2 className="phase-title">{t.missions.phases.studies.title}</h2>
            </div>
            
            <div className="phase-content">
              {t.missions.phases.studies.content.map((paragraph, idx) => (
                <p key={idx} className="phase-text">{paragraph}</p>
              ))}
            </div>
          </section>
        </ScrollReveal>

        {/* Phase Travaux */}
        <ScrollReveal delay={0.7}>
          <section className="mission-phase-section">
            <div className="phase-header">
              <div className="phase-icon">
                <HardHat size={40} strokeWidth={1.5} />
              </div>
              <h2 className="phase-title">{t.missions.phases.works.title}</h2>
            </div>
            
            <div className="phase-subsections">
              {t.missions.phases.works.subsections.map((subsection, idx) => (
                <div key={idx} className="phase-subsection">
                  <h3 className="phase-subtitle">{subsection.title}</h3>
                  {subsection.content.map((paragraph, pIdx) => (
                    <p key={pIdx} className="phase-text">{paragraph}</p>
                  ))}
                </div>
              ))}
            </div>
          </section>
        </ScrollReveal>

        {/* Chantier vert */}
        <ScrollReveal delay={0.8}>
          <section className="mission-phase-section highlight">
            <div className="phase-header">
              <div className="phase-icon green">
                <Leaf size={40} strokeWidth={1.5} />
              </div>
              <h2 className="phase-title">{t.missions.phases.greenSite.title}</h2>
            </div>
            
            <div className="phase-content">
              {t.missions.phases.greenSite.content.map((paragraph, idx) => (
                <p key={idx} className="phase-text">{paragraph}</p>
              ))}
            </div>
          </section>
        </ScrollReveal>

        {/* Intégration paysagère */}
        <ScrollReveal delay={0.9}>
          <section className="mission-phase-section highlight">
            <div className="phase-header">
              <div className="phase-icon green">
                <Trees size={40} strokeWidth={1.5} />
              </div>
              <h2 className="phase-title">{t.missions.phases.landscape.title}</h2>
            </div>
            
            <div className="phase-content">
              {t.missions.phases.landscape.content.map((paragraph, idx) => (
                <p key={idx} className="phase-text">{paragraph}</p>
              ))}
            </div>
          </section>
        </ScrollReveal>

        {/* Section "Notre approche" */}
        <ScrollReveal delay={1.0}>
          <div className="missions-approach">
            <h2 className="approach-title">{t.missions.approach.title}</h2>

            {/* Détails de l'approche */}
            <div className="approach-details">
              {t.missions.approach.details.map((detail, idx) => (
                <div key={idx} className="approach-detail-item">
                  <div className="approach-detail-number">{idx + 1}</div>
                  <div className="approach-detail-content">
                    <h4 className="approach-detail-title">{detail.title}</h4>
                    <p className="approach-detail-text">{detail.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="approach-grid">
              {t.missions.approach.items.map((item, idx) => (
                <div key={idx} className="approach-item">
                  <h3 className="approach-item-title">{item.title}</h3>
                  <p className="approach-item-text">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
}